import { useCallback } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { useActiveBrand } from '../../../../components/branding/useActiveBrand';
import { showSystemNotificationToBackgroundUser } from '../../../../notifications/systemNotifications';
import { areSystemNotificationsEnabled } from '../../../notifications';
import { useAdmissionSystemNotificationsTrackingEvents } from './useAdmissionSystemNotificationsTrackingEvents';

/**
 * Returns a callback that shows a system notification to a backgrounded client
 * when they're admitted, if they're in the experiment group.
 */
export function useShowAdmissionSystemNotificationCallback() {
  const t = useTranslate();
  const brand = useActiveBrand();
  const { trackSystemNotificationForAdmissionViewed, trackSystemNotificationForAdmissionClicked } =
    useAdmissionSystemNotificationsTrackingEvents();

  return useCallback(() => {
    if (!areSystemNotificationsEnabled()) return;

    showSystemNotificationToBackgroundUser({
      title: t('telehealth-core:notifications.joinYourSession'),
      body: t('telehealth-core:notifications.yourProviderIsReadyToBegin'),
      brand,
      onShow: trackSystemNotificationForAdmissionViewed,
      onClick: trackSystemNotificationForAdmissionClicked,
    });
  }, [t, brand, trackSystemNotificationForAdmissionViewed, trackSystemNotificationForAdmissionClicked]);
}
